var _rect, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneLaneRoadWithParking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 100,
    x: -100,
    y: -50,
    fill: "#3a4149"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "translate(40,0)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "translate(80,0)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "translate(120,0)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "translate(160,0)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "rotate(180)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "rotate(180) translate(40,0) "
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "rotate(180) translate(80,0)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "rotate(180) translate(120,0)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-lot",
    transform: "rotate(180) translate(160,0)"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "translate(5,0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "parking-lot"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 20,
    x: -100,
    y: -50,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-74,-35) rotate(270)",
    fontSize: 16,
    fontFamily: "Arial",
    opacity: 0.7,
    fill: "#FFF"
  }, "\r\n                P\r\n            ")), /*#__PURE__*/React.createElement("path", {
    id: "road-lines",
    d: "     M -100 0     L 120 0",
    stroke: "#FFF",
    strokeWidth: 1,
    strokeDasharray: "12 10",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLaneRoadWithParking);
export default __webpack_public_path__ + "static/media/one-lane-road-with-parking.59e9ebbf53b6dfd65f03282834a39a8c.svg";
export { ForwardRef as ReactComponent };